<template>
  <LayoutDefault>
    Подвал
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'

export default {
  name: 'FooterEditorView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
